<template>
  <NuxtLayout name="clean">
    <template #header>
      <AppHeader z-10 />
    </template>

    <div class="branding" overflow-y-auto w-full>
      <slot />
    </div>
  </NuxtLayout>
</template>
